import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchbannerlistmo = async () => {
  
  try {
    const response = await fetch(`${API_URL}/banner_list_mo`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};
